import { Component, Input } from '@angular/core';
import { AppState } from '../../../../app.service';
import { Service } from './deleted-vapps.service';
import { getDatatableConfig } from './deleted-vapps.dt.config';
import { TranslateService, TranslatePipe, LangChangeEvent, TranslationChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
var $ = require('jquery');

@Component({
  selector: 'deleted-vapps',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./deleted-vapps.scss')],
  template: require('./deleted-vapps.html')
})

export class DeletedVapps {
  @Input('isVisible') isVisible: boolean;
  @Input('selectedVDC') selectedVDC;
  @Input() allDelVapp: boolean = false;
  tableData:any = [];
  private subscribeHandler;

  private tableSettings : Object = {};
  private tableConfig : Object = {};
  private currentSelection;
  private isRowSelected: boolean = false;
  private isTranslationready:boolean = true;
  private gridClassesToListen:Array<string> = ['a.restore-points'];
  private isRestorePointsListeningEnabled: boolean = true;
  private showGridLoadingScreen: boolean = false;
  private selectedVapp;
  private isRestorePointsPopupVisible: boolean = false;
  private restorePointsPopupHeader:string;
  private restorePointPopupMode = DataProtectionVariables.RESTORE_MODES['DELETED_VAPP'];

  constructor(public appState: AppState, public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  //Lif Cycle Hooks
  ngOnInit() {
    this.tableConfig = getDatatableConfig(this.translate);
    Object.assign(this.tableSettings, this.tableConfig, {"data": []});
  }

  ngOnChanges(changes) {
    /** Defer the REST call to fetch data, until the component is visible (else too many REST calls while loading).
     * This also helps in fixing the bug 'column headers are misaligned'
     * */
    if(changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue ) {
      this.getAllDeletedVapps();
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    }
  }

  //Listeners
  onGridSelectionChange(event) {
    if(event && event.value && event.value instanceof Array ) {
      this.currentSelection = event.value;
      if(this.currentSelection.length > 0) {
        this.isRowSelected = true;
        if( this.currentSelection[0] && this.currentSelection[0].hasOwnProperty('properties')
            && this.currentSelection[0].properties.hasOwnProperty('vdcId') ) {
              this.selectedVDC = {
                "id":this.currentSelection[0].properties.vdcId
              }
              //Separate from above because this is not a mandatory information and the BE has to include this later
              if( this.currentSelection[0].properties.hasOwnProperty('vdcName') ) {
                this.selectedVDC["name"] = this.currentSelection[0].properties.vdcName;
              }
        }
      }
      else
        this.isRowSelected = false;
    }
  }

  onChildClassClick(event) {
    if(event && event.childClass && event.rowData) {
      this.selectedVapp = event.rowData;
      switch(event.childClass){
        case this.gridClassesToListen[0]:
          this.openRestorePointDialog(event);
          break;
      }
    }
  }

  openRestorePointDialog(event) {
    this.isRestorePointsPopupVisible = true;
    this.restorePointsPopupHeader = this.translate.instant('dpsModule.restorePoints.popupHeaderVapp') + ((this.selectedVapp && this.selectedVapp.name)? " - " + this.selectedVapp.name : "");
  }

  //Custom Logic
  getAllDeletedVapps() {
    if(this.selectedVDC && this.selectedVDC.id && !this.allDelVapp) {
      this.showGridLoadingScreen = true;
      this.subscribeHandler = this.service.getDeletedVappsForVDC(this.selectedVDC.id)
        .subscribe(
          tableData => {
            this.tableData = tableData;
          },
          error => this.logError(error, 'get deleted vApps for vdc'),
          () => this.logOperationCompleted('get deleted vApps for vdc : allDelVapp ' + this.allDelVapp)
        );
    }
    else {
      this.showGridLoadingScreen = true;
      this.subscribeHandler = this.service.getAllDeletedVapps()
        .subscribe(
          tableData => {
            this.tableData = tableData;
          },
          error => this.logError(error, 'get all deleted vApps'),
          () => this.logOperationCompleted('get all deleted vApps : allDelVapp ' + this.allDelVapp)
        );
    }
  }


  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
    this.showGridLoadingScreen = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/deleted-vapps/deleted-vapps.component.ts